import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { ApiResponse, handleAxiosError } from "./responses/AxiosResponseHandler";

interface GroupClubRequestPayload {
  groupId: string;
  clublistingId: string;
}

class GroupClubRequestsApi {
  private authClient: AuthClient;

  constructor(authClient: AuthClient) {
    this.authClient = authClient;
  }

  public async addClubRequest(
    groupId: string,
    clublistingId: string
  ): Promise<ApiResponse<void> | undefined> {
    try {
      const authenticationResponse = this.authClient.getAuthenticationResponse();
      if (!authenticationResponse) {
        return undefined;
      }

      const payload: GroupClubRequestPayload = {
        groupId,
        clublistingId,
      };

      const response = await axios.post(
        `${this.authClient.getApiRoot()}/groups/myparties/${groupId}/clubRequests`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authenticationResponse.token}`,
          },
        }
      );

      return {
        statusCode: response.status,
        errorMessage: "",
      };
    } catch (error) {
      const errorResponse = handleAxiosError<void>(error as AxiosError);
      return {
        statusCode: errorResponse.statusCode,
        errorMessage: errorResponse.errorMessage,
        data: errorResponse.data,
      };
    }
  }

  public async removeClubRequest(
    groupId: string,
    clublistingId: string
  ): Promise<ApiResponse<void> | undefined> {
    try {
      const authenticationResponse = this.authClient.getAuthenticationResponse();
      if (!authenticationResponse) {
        return undefined;
      }

      const payload: GroupClubRequestPayload = {
        groupId,
        clublistingId,
      };

      const response = await axios.delete(
        `${this.authClient.getApiRoot()}/groups/myparties/${groupId}/clubRequests`,
        {
          data: payload,
          headers: {
            Authorization: `Bearer ${authenticationResponse.token}`,
          },
        }
      );

      return {
        statusCode: response.status,
        errorMessage: "",
      };
    } catch (error) {
      const errorResponse = handleAxiosError<void>(error as AxiosError);
      return {
        statusCode: errorResponse.statusCode,
        errorMessage: errorResponse.errorMessage,
        data: errorResponse.data,
      };
    }
  }
}

export default GroupClubRequestsApi;
